import React from "react";
import styled from "styled-components";
import Styles from "../../utils/styles";
import Colors from "../../utils/colors";
import { Link } from "gatsby";

const Wrapper = styled.div`
  .btn {
    background: ${({ backgroundColor, secondaryColor }) =>
      `linear-gradient(to right, ${secondaryColor} 50%, ${backgroundColor} 50%)`};
    background-size: 200% auto;
    background-position-x: 100%;
    color: white;
    border-radius: 20px;
    padding: 10px 30px;
    box-shadow: none;
    outline: none;
    border: none;
    align-self: flex-end;
    justify-self: flex-end;
    margin: 0 20px 10px 20px;
    box-sizing: border-box;
    font-family: ${Styles.FONTS.FONT_TITLE};
    text-transform: uppercase;
    appearance: none;
    font-size: var(--small-font-size);
    cursor: pointer;
    transition: background-position-x 0.5s, color 0.25s;
  }

  .btn:hover,
  .btn:focus {
    color: ${({ backgroundColor }) => backgroundColor} !important;
    background-position-x: 0%;
  }
`;

const Button = ({
  value,
  type = "submit",
  children,
  style,
  onClick,
  backgroundColor = Colors.PINK,
  secondaryColor = Colors.WHITE,
  to,
  className = "",
}) => (
  <Wrapper
    backgroundColor={backgroundColor}
    className={className}
    secondaryColor={secondaryColor}
  >
    {type === "submit" && (
      <input
        className="btn"
        type={type}
        name={"submit"}
        id={"submit"}
        value={value}
        style={style}
      />
    )}
    {type === "button" && (
      <button className="btn" style={style} onClick={onClick}>
        {children}
      </button>
    )}
    {type === "link" && (
      <Link className="btn" style={style} to={to}>
        {children}
      </Link>
    )}
  </Wrapper>
);

export default Button;
